import { render, staticRenderFns } from "./MenuXPerfilPage.vue?vue&type=template&id=172a6b78"
import script from "./MenuXPerfilPage.vue?vue&type=script&lang=js"
export * from "./MenuXPerfilPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports